import { useEffect, useRef } from "react";
import clsx from "clsx";
import "./description-field.css";

const DescriptionField = ({
	label,
	value,
	onChange,
	containerClass,
	inputClassName
}) => {
	const editorRef = useRef(null);

	useEffect(() => {
		const el = editorRef.current;
		if (!el) return;

		const safeValue = value || "";
		if (el.innerHTML !== safeValue) {
			el.innerHTML = safeValue;
		}
	}, [value]);

	const handleInput = () => {
		const el = editorRef.current;
		if (!el || !onChange) return;

		onChange(el.innerHTML);
	};

	const handlePaste = e => {
		const clipboardData = e.clipboardData || window.clipboardData;
		if (!clipboardData || !clipboardData.items) return;

		const items = clipboardData.items;
		let handledImage = false;

		for (let i = 0; i < items.length; i++) {
			const item = items[i];
			if (item.type.indexOf("image") !== -1) {
				handledImage = true;
				e.preventDefault();

				const file = item.getAsFile();
				const reader = new FileReader();

				reader.onload = ev => {
					const editor = editorRef.current;
					if (!editor) return;

					const img = document.createElement("img");
					img.src = ev.target.result;
					img.className = "rt-image";
					img.style.maxWidth = "100%";
					img.style.display = "block";
					img.style.margin = "8px 0";

					let sel = window.getSelection();
					let range;

					if (sel && sel.rangeCount > 0) {
						range = sel.getRangeAt(0);
					} else {
						range = document.createRange();
						range.selectNodeContents(editor);
						range.collapse(false);
					}

					range.insertNode(img);

					range.setStartAfter(img);
					range.setEndAfter(img);
					sel.removeAllRanges();
					sel.addRange(range);

					handleInput();
				};

				reader.readAsDataURL(file);
				break;
			}
		}

		if (!handledImage) {
			return;
		}
	};

	return (
		<div className={clsx("input-field", containerClass)}>
			<span className="input-field__title">{label}</span>
			<div
				ref={editorRef}
				className={clsx("input-field__input", "rich-textarea", inputClassName)}
				contentEditable
				suppressContentEditableWarning
				onInput={handleInput}
				onPaste={handlePaste}
			/>
		</div>
	);
};

export default DescriptionField;
